import { ChangeEvent } from 'react';
import tw, { TwStyle } from 'twin.macro';
import { CSSProp } from 'styled-components';

import { SearchIcon } from '@icons/SearchIcon';
import { CloseIcon } from '@icons/CloseIcon';

const Wrapper = tw.div`flex flex-row items-center justify-start gap-2 border border-gray-1 rounded-md px-3 transition-all duration-300 bg-neutral-background`;
const IconWrapper = tw.label`min-w-[16px] cursor-pointer`;
const ActionWrapper = tw.div`flex items-center justify-center gap-1`;
const Separator = tw.div`w-[0px] h-[19px] bg-gray-1 border-l border-gray-1 rounded-full`;
const CloseButton = tw.div`flex justify-center items-center min-w-[16px] h-[16px] cursor-pointer`;

const SearchBar = ({
  onChange,
  placeholder,
  className,
  inputStyles,
  value = '',
  css,
  withSeparator = false,
  onFocus,
  onBlur,
}: {
  onChange: (val: string) => void;
  placeholder?: string;
  className?: string;
  inputStyles?: TwStyle;
  value?: string;
  css?: CSSProp;
  withSeparator?: boolean;
  onFocus?: () => void;
  onBlur?: () => void;
}) => {
  const handleChange = (event: ChangeEvent<HTMLInputElement>) => onChange(event.target.value);
  const handleClose = () => onChange('');

  return (
    <Wrapper className={className} css={css}>
      <IconWrapper htmlFor='search-bar'>
        <SearchIcon tw='stroke-text-and-icon-muted' />
      </IconWrapper>
      <input
        id='search-bar'
        tw='w-full h-full text-text-and-icon bg-transparent outline-none placeholder:text-text-and-icon-muted'
        css={[inputStyles]}
        type='text'
        placeholder={placeholder}
        value={value}
        onChange={handleChange}
        onFocus={onFocus}
        onBlur={onBlur}
      />
      {withSeparator ? (
        <ActionWrapper>
          <Separator />
          <CloseButton onClick={handleClose}>
            <CloseIcon tw='fill-text-and-icon-muted w-[8px] h-[8px]' />
          </CloseButton>
        </ActionWrapper>
      ) : (
        value && (
          <CloseIcon
            tw='fill-text-and-icon-muted cursor-pointer h-[10px] w-[10px]'
            onClick={handleClose}
          />
        )
      )}
    </Wrapper>
  );
};

export { SearchBar };
